import { ShippingMethodInput } from "@zaprooecommerce/magento-types";
import { ShippingMethodStringify } from "../types";

export function shippingMethodToKey(
  method: ShippingMethodInput,
): ShippingMethodStringify {
  return `${method.carrier_code};${method.method_code}`;
}
